export default {
  methods: {
    checkReasonForDomainQuality(reason) {
      const domainQualityReasons = [
        'dns',
        'black_list',
        'global_blacklist',
        'mask'
      ]
      return domainQualityReasons.includes(reason)
    },
    checkReasonForCPLQuality(reason) {
      return reason === 'performance'
    },
    checkReasonForClassificationCode(classificationCode) {
      return classificationCode === 'w4'
    },
    checkReasonForCTRQuality(reason) {
      return reason === 'ctr'
    },
    checkReasonForBanReasonQuality(reason) {
      return reason === 'other'
    },


    getClassList(row, reason) {
      if (this.highlightReasonProperty !== undefined && !this.highlightReasonProperty) return null

      const classList = {
        domain: {
          'link--danger': this.checkCodeTrashDomain(row.classificationCode)
            || this.checkCodeGlobalBlackList(row.classificationCode)
            || this.checkCodeUserBlacklist(row.classificationCode)
            || this.checkCodeUserMask(row.classificationCode)
        },
        cpl: {
          'text-red': this.checkCodeLowConversionOrHighCPL(row.classificationCode)
        },
        ctr: {
          'text-red': this.checkCodeHighCtr(row.classificationCode)
        },
        clicks: {
          'text-red': this.checkCodeLowConversionOrHighCPL(row.classificationCode)
        }
      }
      return classList[reason]
    },

    checkCodeHighCtr(code) {
      return ['w1', 'w2', 'w3', 'd1', 'd2', 'd3'].includes(code)
    },
    checkCodeLowConversionOrHighCPL(code) {
      return ['w4', 'w5', 'd4', 'b1'].includes(code)
    },
    checkCodeTrashDomain(code) {
      return ['w6'].includes(code)
    },
    checkCodeGlobalBlackList(code) {
      return ['w7'].includes(code)
    },
    checkCodeUserBlacklist(code) {
      return ['w8'].includes(code)
    },
    checkCodeUserMask(code) {
      return ['w9'].includes(code)
    }
  }
}
